import { EmailTab } from '@app-types/enums/email-tab';

export const EMAILS_TABS = {
  [EmailTab.NewAndValidatedUnreadCount]: 'newAndValidatedUnreadCount',
  [EmailTab.NotValidatedUnreadCount]: 'notValidatedUnreadCount',
  [EmailTab.ReassignedUnreadCount]: 'reassignedUnreadCount',
};
